export const getResultStatus = (result: string) => {
  if (result === "FOUND") {
    return {
      label: "FOUND",
      className: "text-green-500 font-semibold",
    };
  }

  if (result.startsWith("FOUND_")) {
    return {
      label: result.replace("FOUND_", "FOUND: "),
      className: "text-yellow-300 font-semibold",
    };
  }

  return {
    label: "NOT FOUND",
    className: "text-red-100 font-semibold",
  };
};
